import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Box,
  Button,
} from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import PrintIcon from "@mui/icons-material/Print";
import * as XLSX from "xlsx-js-style";
import { saveAs } from "file-saver";
import {todayHistoryList} from "../../../Services/Services";
import { useEffect } from "react";
export default function TodayHistoryTable() {
  const [billIdSearch, setBillIdSearch] = useState("");
  const [todayList, settodayList] = useState([]);
  useEffect(() => {
    const todayHistoryListFetchApi = async () => {
      const data = await todayHistoryList();
      settodayList(data);
    };

    todayHistoryListFetchApi();
  }, []);

  const exportToExcel = () => {
    const styledData = todayList.map(
      (
        {
          history_id,
          user_id,
          branch_id,
          bill_id,
          freight_id,
          payment_id,
          issue_id,
          party_id,
          working_type,
          description,
          date,
        },
        index
      ) => ({
        "S. No.": index + 1,
        "History ID": history_id,
        "User ID": user_id,
        "Branch ID": branch_id,
        "Bill ID": bill_id || "-",
        "LR ID": freight_id || "-",
        "Payment ID": payment_id || "-",
        "Issue ID": issue_id || "-",
        "Party ID": party_id || "-",
        "Working Type": working_type,
        Description: description,
        Date: date,
      })
    );
  
    const headers = Object.keys(styledData[0]);
    const worksheetData = [headers, ...styledData.map((row) => Object.values(row))];
  
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
  
    // Auto column width
    const columnWidths = headers.map((_, colIndex) => {
      const maxLength = worksheetData.reduce((max, row) => {
        const cell = row[colIndex];
        const len = cell ? cell.toString().length : 10;
        return Math.max(max, len);
      }, headers[colIndex].length);
      return { wch: maxLength + 2 }; // padding
    });
    worksheet["!cols"] = columnWidths;
  
    const blackBorder = {
      top: { style: "thin", color: { rgb: "000000" } },
      bottom: { style: "thin", color: { rgb: "000000" } },
      left: { style: "thin", color: { rgb: "000000" } },
      right: { style: "thin", color: { rgb: "000000" } },
    };
  
    // Style header row
    headers.forEach((_, colIdx) => {
      const cell = worksheet[XLSX.utils.encode_cell({ r: 0, c: colIdx })];
      if (cell) {
        cell.s = {
          fill: { fgColor: { rgb: "FFFF99" } }, // yellow
          font: { bold: true, color: { rgb: "000000" } },
          alignment: { horizontal: "center", vertical: "center" },
          border: blackBorder,
        };
      }
    });
  
    // Style data rows
    for (let r = 1; r < worksheetData.length; r++) {
      for (let c = 0; c < headers.length; c++) {
        const cell = worksheet[XLSX.utils.encode_cell({ r, c })];
        if (cell) {
          cell.s = {
            alignment: { horizontal: "center", vertical: "center" },
            border: blackBorder,
          };
        }
      }
    }
  
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "TodayHistory");
  
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, "Today_History.xlsx");
  };
  

  const handlePrint = () => {
    const printContents = document.getElementById("history-table").innerHTML;
  
    const printWindow = window.open("", "", "height=600,width=1000");
    printWindow.document.write(`
       <html>
      <head>
        <style>
          body {
            font-family: Arial, sans-serif;
            padding: 0px 20px 0px 20px;
            position: relative;
          }
          header {
            text-align: center;
            font-size: 20px;
            font-weight: bold;
            margin-bottom: 20px;
            color: #333;
          }
          footer {
            position: fixed;
            bottom: 10px;
            width: 100%;
            text-align: center;
            font-size: 12px;
            color: #333;
          }
          table {
            width: 100%;
            border-collapse: collapse;
          }
          th, td {
            border: 1px solid black;
            padding: 8px;
            text-align: center;
            font-size: 12px;
          }
          th {
              background-color:rgba(211, 211, 211, 0.42); /* light grey */
              color: #000;
              -webkit-print-color-adjust: exact; /* For Chrome */
              print-color-adjust: exact;         /* For Firefox */
            }
          .no-print {
            display: none;
          }
        </style>
      </head>
      <body>
        <header>SR ENTERPRICES</header>
        <h3 style="text-align: center;">Today History</h3>
          ${printContents}
        <footer>Powered by : YASHVITECH IT SOLUTION PVT LTD</footer>
        <script>
          window.onload = function() {
            window.print();
            window.onafterprint = function() {
              window.close();
            };
          };
        </script>
      </body>
    </html>
    `);
  
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
  };
  

  const getTimeFromDatetime = (datetimeStr, withSeconds = true) => {
    const date = new Date(datetimeStr);
  
    return date.toLocaleTimeString('en-US', {
      hour12: true,
      hour: '2-digit',
      minute: '2-digit',
      ...(withSeconds && { second: '2-digit' }),
    });
  };


  return (
    <div>
      {/* 🔍 Filter Section */}
      <Box sx={{ display: "flex", gap: 2, mb: 2, flexWrap: "wrap" }}>
      
        <TextField
          label="Search by Bill ID"
          type="text"
          value={billIdSearch}
          onChange={(e) => setBillIdSearch(e.target.value)}
          sx={{ width: "350px" }}
        />
        <Button
          variant="outlined"
          onClick={exportToExcel}
          sx={{ minWidth: "40px", height: "40px", padding: 0 }}
        >
          <FileDownloadIcon fontSize="small" />
        </Button>

        <Button
          variant="outlined"
          onClick={handlePrint}
          sx={{ minWidth: "40px", height: "40px", padding: 0 }}
        >
          <PrintIcon fontSize="small" />
        </Button>
      </Box>

      <TableContainer component={Paper} id="history-table">
        <Table
          size="small"
          sx={{
            "& td, & th": {
              borderBottom: "1px solid #ccc",
              textAlign: "center",
            },
          }}
        >
          <TableHead>
            <TableRow
              sx={{
                "& th": {
                  fontWeight: "bold",
                  whiteSpace: "nowrap",
                  color: (theme) =>
                    theme.palette.mode === "dark" ? "#2196f3" : "#333",
                  backgroundColor: (theme) =>
                    theme.palette.mode === "dark" ? "black" : "#f5f5f5",
                },
              }}
            >
              <TableCell>SR No.</TableCell>
              {/* <TableCell>User ID</TableCell> */}
              {/* <TableCell>Branch ID</TableCell> */}
              <TableCell>Bill ID</TableCell>
              <TableCell>LR ID</TableCell>
              <TableCell>Payment ID</TableCell>
              <TableCell>Issue ID</TableCell>
              {/* <TableCell>Party ID</TableCell> */}
              <TableCell>Working Type</TableCell>
              <TableCell>Description</TableCell>
              <TableCell>Time</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {todayList.map((row, index) => (
              <TableRow
                key={row.history_id}
                sx={{
                  backgroundColor: index % 2 === 0 ? "#fafafa" : "#ffffff",
                  "& td": {
                    fontSize: "0.8125rem",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    maxWidth: 120,
                    color: (theme) =>
                      theme.palette.mode === "dark" ? "white" : "inherit",
                    backgroundColor: (theme) =>
                      theme.palette.mode === "dark" ? "black" : "inherit",
                  },
                }}
              >
                <TableCell>{index+1}</TableCell>
                {/* <TableCell>{row.user_id}</TableCell> */}
                {/* <TableCell>{row.branch_id}</TableCell> */}
                <TableCell>{row.bill_id || "-"}</TableCell>
                <TableCell>{row.freight_id || "-"}</TableCell>
                <TableCell>{row.payment_id || "-"}</TableCell>
                <TableCell>{row.issue_id || "-"}</TableCell>
                {/* <TableCell>{row.party_id || "-"}</TableCell> */}
                <TableCell>{row.working_type}</TableCell>
                <TableCell>{row.description}</TableCell>
                <TableCell>{getTimeFromDatetime(row.created_at)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
